export default function withCacheBust(url, version) {
  if (!url) return url;
  const v = version || Date.now();
  const hasQuery = url.includes("?");
  return `${url}${hasQuery ? "&" : "?"}v=${v}`;
}
